import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=2f39f54d&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=ts"
export * from "./AccessDenied.vue?vue&type=script&lang=ts"
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=2f39f54d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f39f54d",
  null
  
)

export default component.exports